// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.color-sample-items {\n  width:100%;\n}\n.color-sample-empty-cart{\n  padding:15px;\n  margin:15px auto;\n  text-align:center;\n  max-width:480px;\n  width:100%;\n}\n.color-sample-empty-cart p.bodytext{\n  line-height:1.3;\n  margin-bottom:5px;\n}\n.color-sample-empty-cart a{\n  text-decoration: underline;\n}\n", ""]);
// Exports
module.exports = exports;
